import {get, post, put, destroy} from './config';

const Report = {
    sendBugReport: (data) =>
        post('/v1/bugreport', data),
    sendBugReportDocument: (formData) =>
        post('/v1/bugreportdocument', formData),
}

export default Report;
